import {
  Group,
  HoverCard,
  NumberInput,
  SegmentedControl,
  Text,
  ThemeIcon,
  Tooltip,
} from "@mantine/core";
import {
  IconHelp,
  IconHelpFilled,
  IconMinus,
  IconPlus,
} from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { useLanguage } from "../../../stores/LanguageStore";
import { parseStrToStates } from "../../../functions/utilFunctions";

const defaultSign = "-";

const RelativeDateSelector = ({ field_name, value, setValue, readOnly }) => {
  const lang = useLanguage((s) => s.language);
  const [sign, setSign] = useState(
    value ? parseStrToStates(value)?.sign : defaultSign,
  );
  const [day, setDay] = useState(value ? parseStrToStates(value)?.day : 0);
  const [hour, setHour] = useState(value ? parseStrToStates(value)?.hour : 0);

  useEffect(() => {
    let parts = [];

    parts.push(`${sign}${Math.abs(day)} day`);
    parts.push(`${sign}${Math.abs(hour)} hour`);
    parts.push(`${sign}${Math.abs(0)} minute`);

    // Join all parts into a single string, which PHP can interpret via strtotime
    const result = parts.join(" ");

    setValue(result);
  }, [day, hour, sign]);

  return (
    <Group>
      {field_name === "last_call" && (
        <>
          <SegmentedControl
            data={[
              { value: "-", label: <IconMinus size={14} color="black" /> },
              { value: "+", label: <IconPlus size={14} color="black" /> },
            ]}
            value={sign}
            onChange={setSign}
            styles={{ label: { fontSize: 14, lineHeight: 1 } }}
            readOnly={readOnly}
          />
          <HoverCard position="top" withArrow zIndex={999}>
            <HoverCard.Target>
              <ThemeIcon variant="light" radius={"xl"} ml={-14}>
                <IconHelpFilled />
              </ThemeIcon>
            </HoverCard.Target>
            <HoverCard.Dropdown>
              <Text>{lang.table.toolbar.filter.date_tooltip.past}</Text>
              <Text>{lang.table.toolbar.filter.date_tooltip.future}</Text>{" "}
              <Text>{lang.table.toolbar.filter.date_tooltip.example_past}</Text>
              <Text>
                {lang.table.toolbar.filter.date_tooltip.example_future}
              </Text>
            </HoverCard.Dropdown>
          </HoverCard>
        </>
      )}
      <NumberInput
        w={100}
        leftSection={lang.workflows.nodes.events.delay.day}
        placeholder={lang.workflows.nodes.events.delay.day}
        value={day}
        onChange={setDay}
        min={0}
        max={30}
        styles={{
          section: {
            fontSize: 10,
          },
        }}
        leftSectionWidth={50}
        readOnly={readOnly}
      />
      <NumberInput
        w={100}
        leftSection={lang.workflows.nodes.events.delay.hour}
        placeholder={lang.workflows.nodes.events.delay.hour}
        value={hour}
        onChange={setHour}
        max={23}
        min={0}
        styles={{
          section: {
            fontSize: 10,
          },
        }}
        leftSectionWidth={50}
        readOnly={readOnly}
      />
      {/* <NumberInput
        w={90}
        leftSection={lang.workflows.nodes.events.delay.minute}
        placeholder={lang.workflows.nodes.events.delay.minute}
        value={minute}
        onChange={setMinute}
        max={59}
        min={0}
        styles={{
          section: {
            fontSize: 10,
          },
        }}
        leftSectionWidth={50}
      /> */}
    </Group>
  );
};

export default RelativeDateSelector;
